/* Casper Schools Creative Profile Quiz. Built from webapp/ - edit the source, then run npm run build:shopify. */
(() => {
  // webapp/js/data.js
  var answerOptions = [
    { value: -3, en: "Much more like the left", th: "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E1D\u0E31\u0E48\u0E07\u0E0B\u0E49\u0E32\u0E22\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19" },
    { value: -2, en: "More like the left", th: "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E1D\u0E31\u0E48\u0E07\u0E0B\u0E49\u0E32\u0E22\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32" },
    { value: -1, en: "Slightly more like the left", th: "\u0E40\u0E2D\u0E19\u0E21\u0E32\u0E17\u0E32\u0E07\u0E1D\u0E31\u0E48\u0E07\u0E0B\u0E49\u0E32\u0E22\u0E40\u0E25\u0E47\u0E01\u0E19\u0E49\u0E2D\u0E22" },
    { value: 1, en: "Slightly more like the right", th: "\u0E40\u0E2D\u0E19\u0E21\u0E32\u0E17\u0E32\u0E07\u0E1D\u0E31\u0E48\u0E07\u0E02\u0E27\u0E32\u0E40\u0E25\u0E47\u0E01\u0E19\u0E49\u0E2D\u0E22" },
    { value: 2, en: "More like the right", th: "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E1D\u0E31\u0E48\u0E07\u0E02\u0E27\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32" },
    { value: 3, en: "Much more like the right", th: "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E1D\u0E31\u0E48\u0E07\u0E02\u0E27\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19" }
  ];
  var questions = [
    {
      id: "q01",
      axis: "x",
      direction: 1,
      weight: 1,
      leftPole: "responsive",
      rightPole: "expressive",
      prompt: { th: "\u0E2D\u0E30\u0E44\u0E23\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E27\u0E48\u0E32\u0E07\u0E32\u0E19\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08", en: "What makes a project feel successful to you?" },
      left: { th: "\u0E07\u0E32\u0E19\u0E15\u0E2D\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E41\u0E25\u0E30\u0E17\u0E33\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E14\u0E35", en: "The work responds well to the brief and fulfills its purpose." },
      right: { th: "\u0E07\u0E32\u0E19\u0E16\u0E48\u0E32\u0E22\u0E17\u0E2D\u0E14\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E2D\u0E01\u0E21\u0E32\u0E44\u0E14\u0E49", en: "The work expresses a distinctive personal point of view." }
    },
    {
      id: "q02",
      axis: "x",
      direction: -1,
      weight: 1,
      leftPole: "expressive",
      rightPole: "responsive",
      prompt: { th: "\u0E40\u0E27\u0E25\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E07\u0E32\u0E19", en: "When choosing a direction for a project\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E21\u0E32\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14", en: "I choose the direction that feels closest to my own perspective." },
      right: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E0A\u0E21\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E1A\u0E17\u0E21\u0E32\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14", en: "I choose the direction that best suits the audience and context." }
    },
    {
      id: "q03",
      axis: "x",
      direction: 1,
      weight: 1,
      leftPole: "responsive",
      rightPole: "expressive",
      prompt: { th: "\u0E40\u0E27\u0E25\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E07\u0E32\u0E19\u0E43\u0E2A\u0E48 Portfolio", en: "When selecting work for my portfolio\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E44\u0E14\u0E49\u0E14\u0E35", en: "I choose work that shows how well I understood and solved the problem." },
      right: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E09\u0E31\u0E19\u0E21\u0E35\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E44\u0E2B\u0E19", en: "I choose work that shows my personal point of view." }
    },
    {
      id: "q04",
      axis: "x",
      direction: -1,
      weight: 1,
      leftPole: "expressive",
      rightPole: "responsive",
      prompt: { th: "\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E32\u0E01\u0E43\u0E2B\u0E49\u0E04\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E33\u0E07\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E23\u0E32\u0E30\u0E2D\u0E30\u0E44\u0E23", en: "Why would you like people to choose to work with you?" },
      left: { th: "\u0E40\u0E1E\u0E23\u0E32\u0E30\u0E40\u0E02\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E1A\u0E1A\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19", en: "Because they want my distinctive perspective or creative language." },
      right: { th: "\u0E40\u0E1E\u0E23\u0E32\u0E30\u0E09\u0E31\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E27\u0E34\u0E18\u0E35\u0E17\u0E33\u0E07\u0E32\u0E19\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22", en: "Because I can adapt my approach to a wide range of briefs." }
    },
    {
      id: "q05",
      axis: "x",
      direction: 1,
      weight: 1,
      leftPole: "responsive",
      rightPole: "expressive",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C", en: "When a project is complete\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E1E\u0E2D\u0E43\u0E08\u0E44\u0E14\u0E49 \u0E41\u0E21\u0E49\u0E04\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E39\u0E49\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19", en: "I can feel satisfied even if people do not know I made it." },
      right: { th: "\u0E09\u0E31\u0E19\u0E1E\u0E2D\u0E43\u0E08\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E19\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E49\u0E44\u0E14\u0E49\u0E27\u0E48\u0E32\u0E07\u0E32\u0E19\u0E0A\u0E34\u0E49\u0E19\u0E19\u0E35\u0E49\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E09\u0E31\u0E19", en: "I feel more satisfied when people can recognize something of me in it." }
    },
    {
      id: "q06",
      axis: "x",
      direction: -1,
      weight: 1,
      leftPole: "expressive",
      rightPole: "responsive",
      prompt: { th: "\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E0A\u0E21", en: "When communicating with an audience\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E34\u0E14\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E0A\u0E21\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E41\u0E25\u0E30\u0E15\u0E35\u0E04\u0E27\u0E32\u0E21\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22", en: "I want the work to leave room for different feelings and interpretations." },
      right: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E2A\u0E48\u0E07\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E0A\u0E31\u0E14\u0E41\u0E25\u0E30\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22", en: "I want the work to communicate a clear and purposeful message." }
    },
    {
      id: "q07",
      axis: "x",
      direction: 1,
      weight: 1,
      leftPole: "responsive",
      rightPole: "expressive",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E08\u0E32\u0E01\u0E04\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19", en: "When feedback requires the work to change\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19 \u0E2B\u0E32\u0E01\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E41\u0E25\u0E30\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19", en: "I am willing to change it if it better serves the brief and its users." },
      right: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E23\u0E31\u0E01\u0E29\u0E32\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E41\u0E25\u0E30\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E44\u0E27\u0E49", en: "I want to preserve the parts that reflect my voice and perspective." }
    },
    {
      id: "q08",
      axis: "y",
      direction: -1,
      weight: 1,
      leftPole: "exploratory",
      rightPole: "structured",
      prompt: { th: "\u0E15\u0E2D\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C", en: "At the beginning of a project\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E40\u0E23\u0E34\u0E48\u0E21\u0E25\u0E07\u0E21\u0E37\u0E2D\u0E01\u0E48\u0E2D\u0E19 \u0E41\u0E25\u0E49\u0E27\u0E04\u0E48\u0E2D\u0E22\u0E04\u0E49\u0E19\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23", en: "I prefer to begin making and discover the direction along the way." },
      right: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E41\u0E25\u0E30\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E43\u0E2B\u0E49\u0E0A\u0E31\u0E14\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33", en: "I prefer to define the goals and boundaries before I begin." }
    },
    {
      id: "q09",
      axis: "y",
      direction: 1,
      weight: 1,
      leftPole: "structured",
      rightPole: "exploratory",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22", en: "When developing ideas\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E48\u0E2D\u0E19 \u0E41\u0E25\u0E49\u0E27\u0E08\u0E36\u0E07\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E17\u0E32\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01", en: "I gather and organize information before creating possible directions." },
      right: { th: "\u0E09\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E17\u0E32\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E48\u0E2D\u0E19 \u0E41\u0E25\u0E49\u0E27\u0E04\u0E48\u0E2D\u0E22\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E17\u0E32\u0E07", en: "I begin experimenting with possibilities and gather more information along the way." }
    },
    {
      id: "q10",
      axis: "y",
      direction: -1,
      weight: 1,
      leftPole: "exploratory",
      rightPole: "structured",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22", en: "When choosing between several ideas\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22\u0E17\u0E35\u0E48\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E21\u0E35\u0E1E\u0E25\u0E31\u0E07\u0E41\u0E25\u0E30\u0E2D\u0E22\u0E32\u0E01\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E15\u0E48\u0E2D\u0E21\u0E32\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14", en: "I choose the idea that feels most alive and makes me want to explore further." },
      right: { th: "\u0E09\u0E31\u0E19\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E41\u0E15\u0E48\u0E25\u0E30\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22\u0E01\u0E31\u0E1A\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E41\u0E25\u0E30\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E17\u0E35\u0E48\u0E15\u0E31\u0E49\u0E07\u0E44\u0E27\u0E49", en: "I compare each idea against the goals and criteria I have set." }
    },
    {
      id: "q11",
      axis: "y",
      direction: 1,
      weight: 1,
      leftPole: "structured",
      rightPole: "exploratory",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E19\u0E48\u0E32\u0E2A\u0E19\u0E43\u0E08\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E04\u0E32\u0E14\u0E04\u0E34\u0E14", en: "When I discover something unexpectedly interesting\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E40\u0E01\u0E47\u0E1A\u0E21\u0E31\u0E19\u0E44\u0E27\u0E49\u0E1E\u0E34\u0E08\u0E32\u0E23\u0E13\u0E32 \u0E41\u0E15\u0E48\u0E22\u0E31\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E31\u0E01", en: "I consider it, but continue to use the original goal as my main guide." },
      right: { th: "\u0E09\u0E31\u0E19\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E15\u0E32\u0E21\u0E2A\u0E34\u0E48\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E17\u0E35\u0E48\u0E04\u0E49\u0E19\u0E1E\u0E1A", en: "I am willing to let the work change direction because of the discovery." }
    },
    {
      id: "q12",
      axis: "y",
      direction: -1,
      weight: 1,
      leftPole: "exploratory",
      rightPole: "structured",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19", en: "When I receive a brief that is still unclear\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E44\u0E21\u0E48\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19\u0E19\u0E31\u0E49\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E22\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07", en: "I use the uncertainty as space to experiment with several directions." },
      right: { th: "\u0E09\u0E31\u0E19\u0E2D\u0E22\u0E32\u0E01\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E33\u0E16\u0E32\u0E21\u0E41\u0E25\u0E30\u0E01\u0E23\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E0A\u0E31\u0E14\u0E02\u0E36\u0E49\u0E19\u0E01\u0E48\u0E2D\u0E19", en: "I prefer to clarify the questions and framework before moving forward." }
    },
    {
      id: "q13",
      axis: "y",
      direction: 1,
      weight: 1,
      leftPole: "structured",
      rightPole: "exploratory",
      prompt: { th: "\u0E27\u0E34\u0E18\u0E35\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A\u0E44\u0E2B\u0E19\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E18\u0E23\u0E23\u0E21\u0E0A\u0E32\u0E15\u0E34\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32", en: "Which way of working feels more natural to you?" },
      left: { th: "\u0E04\u0E48\u0E2D\u0E22\u0E46 \u0E1E\u0E31\u0E12\u0E19\u0E32\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E27\u0E32\u0E07\u0E44\u0E27\u0E49", en: "Developing the work through a sequence of planned steps." },
      right: { th: "\u0E2A\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E21\u0E32\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E17\u0E33 \u0E17\u0E14\u0E25\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E32\u0E41\u0E01\u0E49", en: "Moving back and forth between making, experimenting, and revising." }
    },
    {
      id: "q14",
      axis: "y",
      direction: -1,
      weight: 1,
      leftPole: "exploratory",
      rightPole: "structured",
      prompt: { th: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E07\u0E32\u0E19\u0E20\u0E32\u0E22\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E08\u0E33\u0E01\u0E31\u0E14", en: "When working within a limited amount of time\u2026" },
      left: { th: "\u0E09\u0E31\u0E19\u0E23\u0E31\u0E01\u0E29\u0E32\u0E41\u0E1C\u0E19\u0E43\u0E2B\u0E49\u0E22\u0E37\u0E14\u0E2B\u0E22\u0E38\u0E48\u0E19 \u0E41\u0E25\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E17\u0E33", en: "I keep the plan flexible and adjust it based on what I learn while working." },
      right: { th: "\u0E09\u0E31\u0E19\u0E41\u0E1A\u0E48\u0E07\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E0A\u0E48\u0E27\u0E07\u0E41\u0E25\u0E30\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E08\u0E38\u0E14\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E44\u0E27\u0E49\u0E25\u0E48\u0E27\u0E07\u0E2B\u0E19\u0E49\u0E32", en: "I divide the work into stages and set decision points in advance." }
    },
    {
      id: "q15",
      axis: "y",
      direction: 1,
      weight: 1,
      leftPole: "structured",
      rightPole: "exploratory",
      isTieBreaker: true,
      prompt: { th: "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E21\u0E31\u0E01\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E41\u0E1A\u0E1A\u0E44\u0E2B\u0E19", en: "How do your design decisions usually happen?" },
      left: { th: "\u0E09\u0E31\u0E19\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E48\u0E2D\u0E19 \u0E41\u0E25\u0E49\u0E27\u0E08\u0E36\u0E07\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E43\u0E0A\u0E49\u0E21\u0E31\u0E19", en: "I understand the reasoning behind an option before deciding to use it." },
      right: { th: "\u0E09\u0E31\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E27\u0E48\u0E32\u0E19\u0E48\u0E32\u0E08\u0E30\u0E44\u0E1B\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49\u0E01\u0E48\u0E2D\u0E19 \u0E41\u0E25\u0E49\u0E27\u0E04\u0E48\u0E2D\u0E22\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07", en: "I choose what feels worth pursuing, then understand the reasoning afterward." }
    }
  ];
  var poles = {
    responsive: { en: "Responsive", th: "\u0E15\u0E2D\u0E1A\u0E2A\u0E19\u0E2D\u0E07\u0E15\u0E48\u0E2D\u0E1A\u0E23\u0E34\u0E1A\u0E17" },
    expressive: { en: "Expressive", th: "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07" },
    structured: { en: "Structured", th: "\u0E27\u0E32\u0E07\u0E42\u0E04\u0E23\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07" },
    exploratory: { en: "Exploratory", th: "\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E17\u0E32\u0E07" }
  };
  var profiles = {
    strategic_solver: {
      x: "responsive",
      y: "structured",
      name: { en: "The Strategic Solver", th: "\u0E19\u0E31\u0E01\u0E41\u0E01\u0E49\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E25\u0E22\u0E38\u0E17\u0E18\u0E4C" },
      description: {
        en: ["You begin by understanding the problem, the people, and the context\u2014then turn complexity into clear, purposeful solutions. Your signature may not be a recognizable look, but the thoughtful way you think and make decisions."],
        th: ["\u0E04\u0E38\u0E13\u0E40\u0E23\u0E34\u0E48\u0E21\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E42\u0E08\u0E17\u0E22\u0E4C \u0E1C\u0E39\u0E49\u0E04\u0E19 \u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E1A\u0E17 \u0E01\u0E48\u0E2D\u0E19\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E27\u0E32\u0E21\u0E0B\u0E31\u0E1A\u0E0B\u0E49\u0E2D\u0E19\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19 \u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E32\u0E02\u0E2D\u0E07\u0E07\u0E32\u0E19 \u0E41\u0E15\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E27\u0E34\u0E18\u0E35\u0E04\u0E34\u0E14\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E17\u0E35\u0E48\u0E21\u0E35\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22"]
      },
      strengths: {
        en: ["Problem-solving", "Systems thinking", "Clarity", "Adaptability"],
        th: ["\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E1B\u0E31\u0E0D\u0E2B\u0E32", "\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E23\u0E30\u0E1A\u0E1A", "\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19", "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E15\u0E31\u0E27"]
      },
      thrive: {
        en: ["Brand Strategy", "Creative Strategy", "UX/UI", "Product Design", "Service Design", "Information Design", "Design Systems", "Design Research"],
        th: ["Brand Strategy", "Creative Strategy", "UX/UI", "Product Design", "Service Design", "Information Design", "Design Systems", "Design Research"]
      }
    },
    intentional_author: {
      x: "expressive",
      y: "structured",
      name: { en: "The Intentional Author", th: "\u0E19\u0E31\u0E01\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19" },
      description: {
        en: ["You have a distinct point of view and develop it through research, reasoning, and deliberate decisions. You do not simply want the work to look different\u2014you want every element to support what you have to say."],
        th: ["\u0E04\u0E38\u0E13\u0E21\u0E35\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E21\u0E31\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E04\u0E27\u0E49\u0E32 \u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25 \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E15\u0E31\u0E49\u0E07\u0E43\u0E08 \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E2D\u0E22\u0E32\u0E01\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07 \u0E41\u0E15\u0E48\u0E2D\u0E22\u0E32\u0E01\u0E43\u0E2B\u0E49\u0E17\u0E38\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E08\u0E30\u0E1E\u0E39\u0E14"]
      },
      strengths: {
        en: ["Clear vision", "Concept development", "Art direction", "Attention to detail"],
        th: ["\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19", "Concept", "Art Direction", "\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14"]
      },
      thrive: {
        en: ["Art Direction", "Brand Identity", "Editorial Design", "Creative Direction", "Type Design", "Campaign Design", "Independent Practice"],
        th: ["Art Direction", "Brand Identity", "Editorial Design", "Creative Direction", "Type Design", "Campaign Design", "Independent Practice"]
      }
    },
    adaptive_explorer: {
      x: "responsive",
      y: "exploratory",
      name: { en: "The Adaptive Explorer", th: "\u0E19\u0E31\u0E01\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E17\u0E35\u0E48\u0E22\u0E37\u0E14\u0E2B\u0E22\u0E38\u0E48\u0E19" },
      description: {
        en: ["You discover answers by making, experimenting, and responding to what emerges along the way. You adapt easily to different briefs and people, often finding possibilities that were not visible at the beginning."],
        th: ["\u0E04\u0E38\u0E13\u0E04\u0E49\u0E19\u0E1E\u0E1A\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E21\u0E37\u0E2D \u0E17\u0E14\u0E25\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E17\u0E32\u0E07 \u0E04\u0E38\u0E13\u0E1B\u0E23\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E40\u0E02\u0E49\u0E32\u0E01\u0E31\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E41\u0E25\u0E30\u0E1C\u0E39\u0E49\u0E04\u0E19\u0E44\u0E14\u0E49\u0E14\u0E35 \u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E43\u0E2B\u0E21\u0E48\u0E46 \u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E1C\u0E19\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E41\u0E23\u0E01"]
      },
      strengths: {
        en: ["Curiosity", "Experimentation", "Flexibility", "Collaboration"],
        th: ["\u0E04\u0E27\u0E32\u0E21\u0E2D\u0E22\u0E32\u0E01\u0E23\u0E39\u0E49\u0E2D\u0E22\u0E32\u0E01\u0E40\u0E2B\u0E47\u0E19", "\u0E01\u0E32\u0E23\u0E17\u0E14\u0E25\u0E2D\u0E07", "\u0E04\u0E27\u0E32\u0E21\u0E22\u0E37\u0E14\u0E2B\u0E22\u0E38\u0E48\u0E19", "\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19"]
      },
      thrive: {
        en: ["Multidisciplinary Design", "Experience Design", "Interaction Design", "Creative Technology", "Innovation Design", "Facilitation", "Collaborative Practice"],
        th: ["Multidisciplinary Design", "Experience Design", "Interaction Design", "Creative Technology", "Innovation Design", "Facilitation", "Collaborative Practice"]
      }
    },
    expressive_creator: {
      x: "expressive",
      y: "exploratory",
      name: { en: "The Expressive Creator", th: "\u0E19\u0E31\u0E01\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E02\u0E31\u0E1A\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E15\u0E19" },
      description: {
        en: ["You create from personal interests, emotions, and instinct, using experimentation to discover what you want to express. Your work draws energy from originality and invites others to feel, imagine, and interpret."],
        th: ["\u0E04\u0E38\u0E13\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E07\u0E32\u0E19\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E19\u0E43\u0E08 \u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E2A\u0E31\u0E0D\u0E0A\u0E32\u0E15\u0E0D\u0E32\u0E13\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E32\u0E01\u0E2A\u0E37\u0E48\u0E2D \u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E1E\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19\u0E09\u0E1A\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E04\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01 \u0E08\u0E34\u0E19\u0E15\u0E19\u0E32\u0E01\u0E32\u0E23 \u0E41\u0E25\u0E30\u0E15\u0E35\u0E04\u0E27\u0E32\u0E21"]
      },
      strengths: {
        en: ["Self-expression", "Originality", "Instinct", "Experimentation"],
        th: ["\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2D\u0E2D\u0E01", "\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19\u0E09\u0E1A\u0E31\u0E1A", "\u0E2A\u0E31\u0E0D\u0E0A\u0E32\u0E15\u0E0D\u0E32\u0E13", "\u0E01\u0E32\u0E23\u0E17\u0E14\u0E25\u0E2D\u0E07"]
      },
      thrive: {
        en: ["Illustration", "Independent Design", "Motion Design", "Image-making", "Experimental Graphic Design", "Art and Design Practice", "Creative Content"],
        th: ["Illustration", "Independent Design", "Motion Design", "Image-making", "Experimental Graphic Design", "Art and Design Practice", "Creative Content"]
      }
    }
  };
  var disclaimer = {
    en: "This profile reflects your current tendencies\u2014not a fixed definition of who you are. You may shift depending on the project, context, and stage of your life.",
    th: "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E19\u0E35\u0E49\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19\u0E41\u0E19\u0E27\u0E42\u0E19\u0E49\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49 \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E04\u0E33\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E15\u0E32\u0E22\u0E15\u0E31\u0E27 \u0E40\u0E1E\u0E23\u0E32\u0E30\u0E15\u0E31\u0E27\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E42\u0E08\u0E17\u0E22\u0E4C \u0E1A\u0E23\u0E34\u0E1A\u0E17 \u0E41\u0E25\u0E30\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E02\u0E2D\u0E07\u0E0A\u0E35\u0E27\u0E34\u0E15"
  };
  var ui = {
    statsTitle: { en: "How others turned out", th: "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E19\u0E17\u0E35\u0E48\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27" },
    statsCount: { en: "{n} people have taken the quiz", th: "{n} \u0E04\u0E19\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27" },
    quizTitle: { en: "Creative Profile Quiz", th: "Creative Profile Quiz" },
    // Start page ("Start page.md"). "\n" = designed line break.
    openingQuestion: { en: "What are you like\nwhen you create?", th: "\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E07\u0E32\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\n\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E1A\u0E1A\u0E44\u0E2B\u0E19?" },
    openingStatement: { en: "\u201CNo two creatives are the same.\u201D", th: "\u201C\u0E44\u0E21\u0E48\u0E21\u0E35\u0E19\u0E31\u0E01\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E04\u0E19\u0E44\u0E2B\u0E19\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E01\u0E31\u0E19\u201D" },
    openingDescription: {
      en: "This quiz invites you to explore\nhow you think and create\u2014\nso you can understand yourself better\nand see what kind of work feels right for you.",
      th: "\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E19\u0E35\u0E49\u0E08\u0E30\u0E0A\u0E27\u0E19\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E23\u0E27\u0E08\n\u0E27\u0E34\u0E18\u0E35\u0E04\u0E34\u0E14\u0E41\u0E25\u0E30\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\n\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19\n\u0E41\u0E25\u0E30\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A\u0E44\u0E2B\u0E19\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13"
    },
    beginButton: { en: "Let\u2019s Begin", th: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E40\u0E25\u0E22" },
    // How to take the quiz ("Start page.md": Artboard 3). <b> = bold in the design.
    howtoTitle: { en: "How to Take the Quiz", th: "\u0E27\u0E34\u0E18\u0E35\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A" },
    howtoDetails: { en: "15 questions \xB7 60 seconds each", th: "15 \u0E04\u0E33\u0E16\u0E32\u0E21 \xB7 \u0E02\u0E49\u0E2D\u0E25\u0E30 60 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35" },
    howtoPerspectives: {
      en: "Each question presents two perspectives\u2014\nand sometimes both may sound like you.",
      th: "\u0E41\u0E15\u0E48\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E08\u0E30\u0E21\u0E35\u0E2A\u0E2D\u0E07\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\n\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E27\u0E48\u0E32 \u201C\u0E01\u0E47\u0E43\u0E0A\u0E48\u0E17\u0E31\u0E49\u0E07\u0E04\u0E39\u0E48\u0E19\u0E30\u201D"
    },
    howtoStep1: { en: "Choose the side that feels closer to you.", th: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1D\u0E31\u0E48\u0E07\u0E17\u0E35\u0E48\u0E43\u0E01\u0E25\u0E49\u0E40\u0E04\u0E35\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32" },
    howtoStep2: { en: "Choose how strongly it feels like you.", th: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E17\u0E35\u0E48\u0E23\u0E39\u0E49\u0E2A\u0E36\u0E01\u0E27\u0E48\u0E32\u0E43\u0E0A\u0E48\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14" },
    leftLabel: { en: "Left", th: "\u0E0B\u0E49\u0E32\u0E22" },
    rightLabel: { en: "Right", th: "\u0E02\u0E27\u0E32" },
    strengthHigh: { en: "Strongly", th: "\u0E21\u0E32\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14" },
    strengthMedium: { en: "More", th: "\u0E21\u0E32\u0E01" },
    strengthLow: { en: "Slightly", th: "\u0E19\u0E34\u0E14\u0E2B\u0E19\u0E48\u0E2D\u0E22" },
    answerGuidance: {
      en: "Answer based on who you are <b>right now</b>,\nnot who you think you should be.",
      th: "\u0E15\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E15\u0E31\u0E27\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E08\u0E23\u0E34\u0E07\u0E46 <b>\u0E43\u0E19\u0E0A\u0E48\u0E27\u0E07\u0E19\u0E35\u0E49</b>\n\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E04\u0E27\u0E23\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19"
    },
    timeoutGuidance: {
      en: "<b>If time runs out</b>, the question will be skipped\nand won\u2019t count toward your result.",
      th: "<b>\u0E2B\u0E32\u0E01\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32</b> \u0E02\u0E49\u0E2D\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E02\u0E49\u0E32\u0E21\n\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E19\u0E33\u0E21\u0E32\u0E04\u0E34\u0E14\u0E04\u0E30\u0E41\u0E19\u0E19"
    },
    notFixedGuidance: {
      en: "There are no right or wrong answers.\n<b>Your result isn\u2019t a fixed label\u2014</b>\nbecause you and your creative process can always change.",
      th: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E34\u0E14\n<b>\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E04\u0E33\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E15\u0E32\u0E22\u0E15\u0E31\u0E27</b>\n\u0E40\u0E1E\u0E23\u0E32\u0E30\u0E15\u0E31\u0E27\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E40\u0E2A\u0E21\u0E2D"
    },
    startButton: { en: "Start the Quiz", th: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A" },
    start: { en: "Start", th: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E40\u0E25\u0E22" },
    registerTitle: { en: "Before you begin", th: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A" },
    registerBody: { en: "Tell us a little about yourself to start the quiz.", th: "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A" },
    nameLabel: { en: "Nickname (in English)", th: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E48\u0E19\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29" },
    emailLabel: { en: "Email", th: "\u0E2D\u0E35\u0E40\u0E21\u0E25" },
    yobLabel: { en: "Year of birth (A.D.)", th: "\u0E1B\u0E35\u0E40\u0E01\u0E34\u0E14 (\u0E04.\u0E28.)" },
    yobPlaceholder: { en: "Select your year of birth", th: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E35\u0E40\u0E01\u0E34\u0E14" },
    consentLabel: {
      en: "I agree that Casper Schools may collect my name, email and year of birth to provide my quiz result, as described in the",
      th: "\u0E09\u0E31\u0E19\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E43\u0E2B\u0E49 Casper Schools \u0E40\u0E01\u0E47\u0E1A\u0E0A\u0E37\u0E48\u0E2D \u0E2D\u0E35\u0E40\u0E21\u0E25 \u0E41\u0E25\u0E30\u0E1B\u0E35\u0E40\u0E01\u0E34\u0E14\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A \u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E43\u0E19"
    },
    privacyPolicy: { en: "Privacy Policy", th: "\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27" },
    marketingLabel: {
      en: "Send me news about Casper Schools courses and events (optional)",
      th: "\u0E2A\u0E48\u0E07\u0E02\u0E48\u0E32\u0E27\u0E2A\u0E32\u0E23\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E04\u0E2D\u0E23\u0E4C\u0E2A\u0E41\u0E25\u0E30\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07 Casper Schools \u0E43\u0E2B\u0E49\u0E09\u0E31\u0E19 (\u0E44\u0E21\u0E48\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A)"
    },
    submit: { en: "Start the quiz", th: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A" },
    errName: { en: "Please enter your nickname in English letters.", th: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E48\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29" },
    errEmail: { en: "Please enter a valid email address.", th: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E43\u0E2B\u0E49\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07" },
    errYob: { en: "Please select your year of birth.", th: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E35\u0E40\u0E01\u0E34\u0E14" },
    errConsent: { en: "Please accept to continue.", th: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D" },
    registerBodyGoogle: {
      en: "Continue with Google, or fill in your details to start the quiz.",
      th: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A"
    },
    registerBodyGoogleFirst: {
      en: "Continue with Google to start the quiz.",
      th: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A"
    },
    manualToggle: { en: "Not using Google? Fill in your details", th: "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E49 Google? \u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2D\u0E07" },
    orFillIn: { en: "or fill in your details", th: "\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2D\u0E07" },
    googleUseOther: { en: "Use a different email", th: "\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E37\u0E48\u0E19" },
    errGoogle: {
      en: "Google sign-in didn't work. Please try again or fill in your details.",
      th: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google \u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2D\u0E07"
    },
    welcomeBack: { en: "Welcome back, {name}", th: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E32 {name}" },
    continueQuiz: { en: "Continue the quiz", th: "\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E15\u0E48\u0E2D" },
    startAs: { en: "Start as {name}", th: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E43\u0E19\u0E0A\u0E37\u0E48\u0E2D {name}" },
    newPerson: { en: "Not {name}? Enter new details", th: "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 {name}? \u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E21\u0E48" },
    questionOf: { en: "{n} of {total}", th: "{n} of {total}" },
    whichSide: { en: "Which side is more like you?", th: "\u0E1D\u0E31\u0E48\u0E07\u0E44\u0E2B\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E38\u0E13\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E01\u0E31\u0E19" },
    timeoutNote: { en: "If time runs out, this question will be skipped and won\u2019t count.", th: "\u0E2B\u0E32\u0E01\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32 \u0E02\u0E49\u0E2D\u0E19\u0E35\u0E49\u0E08\u0E30\u0E16\u0E39\u0E01\u0E02\u0E49\u0E32\u0E21\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E19\u0E33\u0E21\u0E32\u0E04\u0E34\u0E14\u0E04\u0E30\u0E41\u0E19\u0E19" },
    timeUpSkipped: { en: "Time's up, this question is skipped", th: "\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32 \u0E02\u0E49\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E19\u0E35\u0E49" },
    timeLeft: { en: "Time left for this question", th: "\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E19\u0E35\u0E49" },
    yourProfile: { en: "Your Creative Profile", th: "Your Creative Profile" },
    creativeOrientation: { en: "Your Creative Orientation", th: "Your Creative Orientation" },
    creativeProcess: { en: "Your Creative Process", th: "Your Creative Process" },
    strengths: { en: "Your Strengths", th: "\u0E08\u0E38\u0E14\u0E41\u0E02\u0E47\u0E07" },
    thrive: { en: "Where You May Thrive", th: "\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E40\u0E02\u0E49\u0E32\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13" },
    share: { en: "Share", th: "\u0E41\u0E0A\u0E23\u0E4C" },
    resultSaving: { en: "Saving your result\u2026 please keep this page open", th: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E1C\u0E25\u2026 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E07\u0E1B\u0E34\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49" },
    resultSaved: { en: "Result saved \u2713", th: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E1C\u0E25\u0E41\u0E25\u0E49\u0E27 \u2713" },
    retake: { en: "Retake the quiz", th: "\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07" },
    saveHint: {
      en: "Press and hold the image to save it to your photos, then share it on Instagram or Facebook.",
      th: "\u0E01\u0E14\u0E04\u0E49\u0E32\u0E07\u0E17\u0E35\u0E48\u0E23\u0E39\u0E1B\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E25\u0E07\u0E2D\u0E31\u0E25\u0E1A\u0E31\u0E49\u0E21\u0E23\u0E39\u0E1B \u0E41\u0E25\u0E49\u0E27\u0E19\u0E33\u0E44\u0E1B\u0E41\u0E0A\u0E23\u0E4C\u0E43\u0E19 Instagram \u0E2B\u0E23\u0E37\u0E2D Facebook"
    },
    saveImage: { en: "Download image", th: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B" },
    close: { en: "Close", th: "\u0E1B\u0E34\u0E14" },
    openTitle: { en: "Share in one tap from your browser", th: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E04\u0E25\u0E34\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27" },
    openBodyIOS: {
      en: "This app can't share images directly. Tap \u2022\u2022\u2022 in the corner and choose \u201COpen in browser\u201D (or copy the link into Safari). Your result will open there, ready to share.",
      th: "\u0E41\u0E2D\u0E1B\u0E19\u0E35\u0E49\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E39\u0E1B\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49 \u0E41\u0E15\u0E30 \u2022\u2022\u2022 \u0E17\u0E35\u0E48\u0E21\u0E38\u0E21\u0E08\u0E2D \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01 \u201C\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u201D (\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Safari) \u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E21\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E41\u0E0A\u0E23\u0E4C\u0E17\u0E31\u0E19\u0E17\u0E35"
    },
    openBodyAndroid: {
      en: "This app can't share images directly. Open your result in Chrome to share it in one tap.",
      th: "\u0E41\u0E2D\u0E1B\u0E19\u0E35\u0E49\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E39\u0E1B\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49 \u0E40\u0E1B\u0E34\u0E14\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E43\u0E19 Chrome \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E04\u0E25\u0E34\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27"
    },
    openInChrome: { en: "Open in Chrome", th: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Chrome" },
    copyLink: { en: "Copy link", th: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C" },
    copied: { en: "Link copied", th: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E41\u0E25\u0E49\u0E27" },
    saveInstead: { en: "Save the image instead", th: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E39\u0E1B\u0E41\u0E17\u0E19" },
    imageFailed: { en: "Couldn't create the image. Please take a screenshot instead.", th: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E39\u0E1B\u0E44\u0E14\u0E49 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E41\u0E04\u0E1B\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E41\u0E17\u0E19" }
  };

  // webapp/js/scoring.js
  var MAX_ANSWER = 3;
  function getCreativeProfile(xLean, yLean) {
    if (xLean < 0 && yLean < 0) return "strategic_solver";
    if (xLean > 0 && yLean < 0) return "intentional_author";
    if (xLean < 0 && yLean > 0) return "adaptive_explorer";
    return "expressive_creator";
  }
  function getLeanFromItemCount(itemScores) {
    const positiveCount = itemScores.filter((score) => score > 0).length;
    const negativeCount = itemScores.filter((score) => score < 0).length;
    if (positiveCount > negativeCount) return 1;
    if (negativeCount > positiveCount) return -1;
    return 0;
  }
  function lean(raw, items, tieBreakerScore) {
    return Math.sign(raw) || getLeanFromItemCount(items) || (tieBreakerScore > 0 ? 1 : -1);
  }
  function tieBreakerId(questions2, axis) {
    const onAxis = questions2.filter((q) => q.axis === axis);
    return (onAxis.find((q) => q.isTieBreaker) || onAxis[onAxis.length - 1])?.id;
  }
  function calculateQuizResult(answers, questions2) {
    const scores = { x: [], y: [] };
    const maxima = { x: 0, y: 0 };
    const byId = {};
    for (const question of questions2) {
      if (!(question.id in answers)) {
        throw new Error(`Missing answer for ${question.id}`);
      }
      const value = answers[question.id];
      if (typeof value !== "number" || value === 0) continue;
      const weight = question.weight ?? 1;
      const itemScore = value * question.direction * weight;
      scores[question.axis].push(itemScore);
      maxima[question.axis] += MAX_ANSWER * weight;
      byId[question.id] = itemScore;
    }
    const sum = (list) => list.reduce((a, b) => a + b, 0);
    const xRaw = sum(scores.x);
    const yRaw = sum(scores.y);
    const normalise = (raw, max) => max ? Math.round(raw / max * 100) : 0;
    const x = normalise(xRaw, maxima.x);
    const y = normalise(yRaw, maxima.y);
    const expressive = Math.round((x + 100) / 2);
    const responsive = 100 - expressive;
    const exploratory = Math.round((y + 100) / 2);
    const structured = 100 - exploratory;
    return {
      raw: { x: xRaw, y: yRaw },
      normalized: { x, y },
      spectrum: {
        creativeOrientation: { responsive, expressive },
        creativeProcess: { structured, exploratory }
      },
      profile: getCreativeProfile(
        lean(xRaw, scores.x, byId[tieBreakerId(questions2, "x")]),
        lean(yRaw, scores.y, byId[tieBreakerId(questions2, "y")])
      )
    };
  }

  // webapp/js/config.js
  var SHEET_ENDPOINT = "https://script.google.com/macros/s/AKfycbx7L0xx8HrXIUJKDu4ZpYaLPRnci3U4CpXTXiypMZIIJ2cyFdHv6v0skHSiKoeB_FV2/exec";
  var GOOGLE_CLIENT_ID = "469472747796-jrsd060kjdqh2sc0ghnmp2bfn8urof11.apps.googleusercontent.com";
  var STATS_MIN_PEOPLE = 20;
  var SHOW_PEOPLE_COUNT_FROM = 100;
  var IMAGES = window.CPQ_IMAGES || {
    strategic_solver: "images/cpq-ghost-strategic-solver.webp",
    intentional_author: "images/cpq-ghost-intentional-author.webp",
    adaptive_explorer: "images/cpq-ghost-adaptive-explorer.webp",
    expressive_creator: "images/cpq-ghost-expressive-creator.webp",
    group: "images/cpq-ghosts-group.webp"
  };
  var PRIVACY_POLICY_URL = "https://casperschools.co/policies/privacy-policy";
  var DEFAULT_LANG = "th";

  // webapp/js/api.js
  var OUTBOX_KEY = "casper-creative-profile-quiz:outbox";
  var TIMEOUT_MS = 4e4;
  var RETRY_DELAYS_MS = [2e3, 5e3, 1e4, 2e4, 4e4, 6e4];
  var PERMANENT_ERRORS = /* @__PURE__ */ new Set([
    "invalid_id",
    "invalid_name",
    "invalid_email",
    "invalid_year",
    "consent_required",
    "invalid_profile",
    "unknown_action"
  ]);
  var outbox = readOutbox();
  var sending = false;
  var failures = 0;
  var retryTimer = null;
  var statusListener = null;
  function readOutbox() {
    try {
      return JSON.parse(localStorage.getItem(OUTBOX_KEY)) || [];
    } catch {
      return [];
    }
  }
  function writeOutbox() {
    try {
      localStorage.setItem(OUTBOX_KEY, JSON.stringify(outbox));
    } catch {
    }
    statusListener?.(outbox.length);
  }
  function pendingSaves() {
    return outbox.length;
  }
  function onSaveStatusChange(listener) {
    statusListener = listener;
  }
  async function post(payload) {
    if (!SHEET_ENDPOINT) {
      console.info("[test mode] would send to Google Sheet:", payload);
      return { ok: true, testMode: true };
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
    try {
      const res = await fetch(SHEET_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      const data = await res.json();
      if (!data.ok) {
        const err = new Error(data.error || "save_failed");
        err.permanent = PERMANENT_ERRORS.has(data.error);
        throw err;
      }
      return data;
    } finally {
      clearTimeout(timer);
    }
  }
  function scheduleRetry() {
    const base = RETRY_DELAYS_MS[Math.min(failures, RETRY_DELAYS_MS.length - 1)];
    failures += 1;
    clearTimeout(retryTimer);
    retryTimer = setTimeout(flush, base * (0.5 + Math.random()));
  }
  async function flush() {
    if (sending || !outbox.length) return;
    sending = true;
    clearTimeout(retryTimer);
    try {
      while (outbox.length) {
        try {
          await post(outbox[0]);
          failures = 0;
        } catch (err) {
          if (!err.permanent) {
            console.warn("Save failed, will retry:", err.message);
            scheduleRetry();
            return;
          }
          console.error("Save rejected:", err.message, outbox[0]);
        }
        outbox.shift();
        writeOutbox();
      }
    } finally {
      sending = false;
    }
  }
  function enqueue(payload) {
    outbox.push(payload);
    writeOutbox();
    flush();
  }
  window.addEventListener("online", flush);
  var beaconed = /* @__PURE__ */ new Set();
  function sendRemainingOnExit() {
    if (!SHEET_ENDPOINT || !navigator.sendBeacon) return;
    for (const payload of outbox) {
      const body = JSON.stringify(payload);
      if (beaconed.has(body)) continue;
      if (navigator.sendBeacon(SHEET_ENDPOINT, new Blob([body], { type: "text/plain;charset=UTF-8" }))) {
        beaconed.add(body);
      }
    }
  }
  window.addEventListener("pagehide", sendRemainingOnExit);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sendRemainingOnExit();
  });
  function saveRegistration(registration) {
    enqueue({ action: "register", ...registration, pageUrl: location.href });
  }
  function saveResult(registration, lang, answers, timedOut, result) {
    enqueue({
      action: "result",
      ...registration,
      pageUrl: location.href,
      lang,
      answers,
      timedOut,
      profile: result.profile,
      x: result.normalized.x,
      y: result.normalized.y,
      expressive: result.spectrum.creativeOrientation.expressive,
      exploratory: result.spectrum.creativeProcess.exploratory
    });
  }
  var STATS_KEY = "casper-creative-profile-quiz:stats";
  var STATS_MAX_AGE_MS = 10 * 60 * 1e3;
  function readStatsCache() {
    try {
      return JSON.parse(localStorage.getItem(STATS_KEY));
    } catch {
      return null;
    }
  }
  async function loadStats() {
    const cached = readStatsCache();
    if (cached && Date.now() - cached.savedAt < STATS_MAX_AGE_MS) return cached.stats;
    if (!SHEET_ENDPOINT) return null;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15e3);
    try {
      const res = await fetch(`${SHEET_ENDPOINT}?action=stats`, { signal: controller.signal });
      const stats2 = await res.json();
      if (!stats2.ok) throw new Error(stats2.error || "stats_failed");
      try {
        localStorage.setItem(STATS_KEY, JSON.stringify({ savedAt: Date.now(), stats: stats2 }));
      } catch {
      }
      return stats2;
    } catch (err) {
      console.warn("Stats unavailable:", err.message);
      return cached?.stats || null;
    } finally {
      clearTimeout(timer);
    }
  }

  // webapp/js/share.js
  var LIB_URL = "https://cdn.jsdelivr.net/npm/html-to-image@1.11.11/dist/html-to-image.js";
  var RENDER_OPTIONS = { pixelRatio: 2, backgroundColor: "#ffffff" };
  var libPromise = null;
  var cache = /* @__PURE__ */ new Map();
  function loadLib() {
    if (window.htmlToImage) return Promise.resolve();
    if (!libPromise) {
      libPromise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = LIB_URL;
        s.onload = resolve;
        s.onerror = () => {
          libPromise = null;
          reject(new Error("Could not load image library"));
        };
        document.head.appendChild(s);
      });
    }
    return libPromise;
  }
  async function renderOffscreen(node) {
    await loadLib();
    await document.fonts.ready;
    const holder = document.createElement("div");
    holder.style.cssText = "position:fixed;left:-10000px;top:0;pointer-events:none;";
    holder.appendChild(node);
    document.body.appendChild(holder);
    try {
      await window.htmlToImage.toBlob(node, RENDER_OPTIONS);
      return await window.htmlToImage.toBlob(node, RENDER_OPTIONS);
    } finally {
      holder.remove();
    }
  }
  function renderImage(key, buildNode) {
    if (!cache.has(key)) {
      const promise = renderOffscreen(buildNode());
      promise.catch(() => cache.delete(key));
      cache.set(key, promise);
    }
    return cache.get(key);
  }
  function isInAppBrowser() {
    return /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Line\/|TikTok|musical_ly|BytedanceWebview/i.test(navigator.userAgent);
  }
  function isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }
  function isDesktop() {
    return Boolean(window.matchMedia?.("(hover: hover) and (pointer: fine)").matches) && !isInAppBrowser();
  }
  function isIOS() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  }
  async function shareImage(blob, filename) {
    const file = new File([blob], filename, { type: "image/png" });
    if (isInAppBrowser() || !navigator.canShare?.({ files: [file] })) return "unsupported";
    try {
      await navigator.share({ files: [file] });
      return "shared";
    } catch (err) {
      return err.name === "AbortError" ? "cancelled" : "unsupported";
    }
  }
  function downloadImage(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5e3);
  }
  function showSaveOverlay(blob, filename, text) {
    const url = URL.createObjectURL(blob);
    const canDownload = !isInAppBrowser() && !isIOS();
    const overlay = document.createElement("div");
    overlay.className = "save-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", text.hint);
    overlay.innerHTML = `
    <p class="save-hint">${text.hint}</p>
    <img class="save-image" src="${url}" alt="">
    <div class="save-actions ${canDownload ? "" : "single"}">
      ${canDownload ? `<button type="button" class="btn" data-download>${text.download}</button>` : ""}
      <button type="button" class="btn primary" data-close>${text.close}</button>
    </div>`;
    const close = () => {
      overlay.remove();
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
      setTimeout(() => URL.revokeObjectURL(url), 1e3);
    };
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    overlay.querySelector("[data-close]").addEventListener("click", close);
    overlay.querySelector("[data-download]")?.addEventListener("click", () => downloadImage(blob, filename));
    document.addEventListener("keydown", onKey);
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";
    overlay.querySelector("[data-close]").focus();
  }
  function showOpenInBrowser(link, text, onSaveInstead2) {
    const android = isAndroid();
    const chromeIntent = `intent://${link.replace(/^https?:\/\//, "")}#Intent;scheme=${location.protocol.replace(":", "")};package=com.android.chrome;end`;
    const sheet = document.createElement("div");
    sheet.className = "save-overlay open-sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-label", text.title);
    sheet.innerHTML = `
    <div class="open-panel">
      <h2>${text.title}</h2>
      <p>${android ? text.bodyAndroid : text.bodyIOS}</p>
      ${android ? `<a class="btn primary" href="${chromeIntent}">${text.openInChrome}</a>` : ""}
      <button type="button" class="btn ${android ? "" : "primary"}" data-copy>${text.copyLink}</button>
      <input class="open-link" type="text" readonly value="${link}" aria-label="Link">
      <button type="button" class="btn link" data-save>${text.saveInstead}</button>
      <button type="button" class="btn link" data-close>${text.close}</button>
    </div>`;
    const close = () => {
      sheet.remove();
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    const copyBtn = sheet.querySelector("[data-copy]");
    const input = sheet.querySelector(".open-link");
    copyBtn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(link);
      } catch {
        input.focus();
        input.select();
        document.execCommand?.("copy");
      }
      copyBtn.textContent = text.copied;
    });
    sheet.querySelector("[data-close]").addEventListener("click", close);
    sheet.querySelector("[data-save]").addEventListener("click", () => {
      close();
      onSaveInstead2();
    });
    document.addEventListener("keydown", onKey);
    document.body.appendChild(sheet);
    document.body.style.overflow = "hidden";
  }

  // webapp/js/google.js
  var GIS_URL = "https://accounts.google.com/gsi/client";
  var gisPromise = null;
  var onCredential = null;
  function googleAvailable() {
    return Boolean(GOOGLE_CLIENT_ID) && !isInAppBrowser();
  }
  function loadScript() {
    if (window.google?.accounts?.id) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = GIS_URL;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => reject(new Error("Could not load Google sign-in"));
      document.head.appendChild(s);
    });
  }
  function loadGis() {
    if (!gisPromise) {
      gisPromise = loadScript().then(() => {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: (response) => onCredential?.(response.credential),
          ux_mode: "popup",
          auto_select: false,
          itp_support: true
        });
      });
      gisPromise.catch(() => {
        gisPromise = null;
      });
    }
    return gisPromise;
  }
  async function mountGoogleButton(container, lang, callback) {
    onCredential = callback;
    try {
      await loadGis();
    } catch (err) {
      console.warn(err);
      container.closest("[data-google]")?.remove();
      return;
    }
    if (!container.isConnected) return;
    window.google.accounts.id.renderButton(container, {
      type: "standard",
      theme: "outline",
      size: "large",
      text: "continue_with",
      shape: "rectangular",
      logo_alignment: "center",
      width: Math.min(400, Math.round(container.clientWidth) || 320),
      locale: lang
    });
  }
  function readCredential(credential) {
    const part = credential.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const bytes = Uint8Array.from(atob(part), (c) => c.charCodeAt(0));
    const claims = JSON.parse(new TextDecoder().decode(bytes));
    return {
      token: credential,
      email: String(claims.email || "").toLowerCase(),
      name: claims.name || "",
      expiresAt: (claims.exp || 0) * 1e3
    };
  }

  // webapp/js/logo.js
  var LOGO_SVG = '<svg class="logo" viewBox="0 0 1029.72 201.5" fill="currentColor" role="img" aria-label="Casper Schools" xmlns="http://www.w3.org/2000/svg"><path d="M0,100.76C0,44.72,36.64,0,105.51,0,164.86,0,200.42,33.69,205.9,81.7h-57.9c-4.77-19.06-20.52-29.32-42.5-29.32-30.04,0-47.27,20.15-47.27,48.35s17.23,48.35,47.27,48.35c21.98,0,37.75-10.26,42.5-29.32h57.9c-5.12,47.98-41.04,81.7-100.39,81.7C36.64,201.47,0,156.78,0,100.71v.06Z"/><path d="M223.23,138.12h53.5c1.46,15.03,15.75,19.78,39.92,19.78,27.49,0,37.01-6.23,37.01-17.95,0-11-7.32-15.03-22.35-16.49l-43.95-4.03c-40.67-3.66-62.27-20.89-62.27-56.78C225.08,21.6,254.03,0,318.88,0,361.37,0,405.35,9.52,406.07,62.64h-53.13c-1.83-13.92-12.46-19.78-36.27-19.78-21.6,0-34.06,4.77-34.06,18.32,0,10.26,7.32,14.66,22.72,16.12l43.95,4.03c40.67,3.66,62.64,17.95,62.64,55.33,0,42.5-29.32,64.84-96.74,64.84-48.35,0-91.59-11.35-91.96-63.39Z"/><path d="M516.85,44.78c0-26.06-17.03-44.78-44.78-44.78s-45.1,18.72-45.1,44.78,17.38,44.78,45.1,44.78,44.78-18.72,44.78-44.78Z"/><path d="M576.45,41.62c0-19.29,14.85-33.89,34.65-33.89,16.88,0,30.21,10.66,32.88,25.89h-15.11c-2.29-7.24-9.27-12.19-17.77-12.19-11.42,0-20.06,8.76-20.06,20.18s8.63,20.18,20.06,20.18c8.5,0,15.49-4.95,17.77-12.19h15.11c-2.67,15.23-15.99,25.89-32.88,25.89-19.8,0-34.65-14.6-34.65-33.89Z"/><path d="M652.99,41.62c0-19.29,13.58-33.89,31.86-33.89,9.52,0,17.39,4.06,22.72,10.79v-9.27h14.22v64.74h-14.22v-9.27c-5.33,6.73-13.2,10.79-22.72,10.79-18.28,0-31.86-14.6-31.86-33.89ZM707.57,41.62c0-11.42-8.5-20.18-19.93-20.18s-20.06,8.76-20.06,20.18,8.5,20.18,20.06,20.18,19.93-8.76,19.93-20.18Z"/><path d="M734.6,54.95h14.47c0,4.95,4.7,8.25,11.55,8.25,6.35,0,10.54-2.92,10.54-6.98,0-11.68-35.54-5.2-35.54-28.18,0-12.57,10.03-20.31,24.37-20.31s24.63,8,24.63,19.67h-14.47c0-4.44-4.19-7.49-10.28-7.49s-9.9,2.67-9.9,6.6c0,11.3,35.67,5.08,35.67,28.18,0,12.57-10.03,20.82-25.13,20.82s-25.89-8.38-25.89-20.56Z"/><path d="M798.32,9.26h14.22v9.27c5.46-6.73,13.33-10.79,22.85-10.79,18.15,0,31.86,14.6,31.86,33.89s-13.71,33.89-31.86,33.89c-9.52,0-17.39-4.06-22.85-10.79v33.38h-14.22V9.26ZM852.52,41.62c0-11.42-8.5-20.18-19.93-20.18s-20.06,8.76-20.06,20.18,8.63,20.18,20.06,20.18,19.93-8.76,19.93-20.18Z"/><path d="M876.38,41.62c0-19.29,14.85-33.89,34.53-33.89s34.65,14.6,34.65,34.02c0,1.78-.13,3.68-.38,5.33h-53.57c2.16,9.39,9.77,15.61,19.93,15.61,7.49,0,13.96-3.3,17.26-8.25h15.74c-5.2,12.57-17.9,21.07-33.26,21.07-20.06,0-34.91-14.6-34.91-33.89ZM891.74,35.41h38.59c-2.16-8.89-9.77-14.85-19.42-14.85s-16.88,5.84-19.17,14.85Z"/><path d="M958,9.26h14.22v10.79c5.08-7.36,12.57-11.8,21.71-11.8h2.29v14.6h-2.29c-13.71,0-21.71,7.74-21.71,19.68v31.48h-14.22V9.26Z"/><path d="M576.32,173.28h14.47c0,4.95,4.7,8.25,11.55,8.25,6.35,0,10.54-2.92,10.54-6.98,0-11.68-35.54-5.2-35.54-28.18,0-12.57,10.03-20.31,24.37-20.31s24.63,8,24.63,19.67h-14.47c0-4.44-4.19-7.49-10.28-7.49s-9.9,2.67-9.9,6.6c0,11.3,35.67,5.08,35.67,28.18,0,12.57-10.03,20.82-25.13,20.82s-25.89-8.38-25.89-20.56Z"/><path d="M636.1,159.95c0-19.29,14.85-33.89,34.65-33.89,16.88,0,30.21,10.66,32.88,25.89h-15.11c-2.29-7.24-9.27-12.19-17.77-12.19-11.42,0-20.06,8.76-20.06,20.18s8.63,20.18,20.06,20.18c8.5,0,15.49-4.95,17.77-12.19h15.11c-2.67,15.23-15.99,25.89-32.88,25.89-19.8,0-34.65-14.6-34.65-33.89Z"/><path d="M716.58,100.93h14.22v35.29c5.2-6.6,12.69-10.16,21.83-10.16,15.36,0,25.64,10.16,25.64,25.51v40.75h-14.22v-36.05c0-9.9-6.35-16.5-16.12-16.5-10.28,0-17.14,6.73-17.14,16.76v35.8h-14.22v-91.39Z"/><path d="M790.83,159.95c0-19.29,14.85-33.89,34.65-33.89s34.65,14.6,34.65,33.89-14.98,33.89-34.65,33.89-34.65-14.6-34.65-33.89ZM845.42,159.95c0-11.42-8.5-20.18-19.93-20.18s-20.06,8.76-20.06,20.18,8.63,20.18,20.06,20.18,19.93-8.76,19.93-20.18Z"/><path d="M869.02,159.95c0-19.29,14.85-33.89,34.65-33.89s34.65,14.6,34.65,33.89-14.98,33.89-34.65,33.89-34.65-14.6-34.65-33.89ZM923.6,159.95c0-11.42-8.5-20.18-19.93-20.18s-20.06,8.76-20.06,20.18,8.63,20.18,20.06,20.18,19.93-8.76,19.93-20.18Z"/><path d="M951.4,100.93h14.22v91.39h-14.22v-91.39Z"/><path d="M978.69,173.28h14.47c0,4.95,4.7,8.25,11.55,8.25,6.35,0,10.54-2.92,10.54-6.98,0-11.68-35.54-5.2-35.54-28.18,0-12.57,10.03-20.31,24.37-20.31s24.63,8,24.63,19.67h-14.47c0-4.44-4.19-7.49-10.28-7.49s-9.9,2.67-9.9,6.6c0,11.3,35.67,5.08,35.67,28.18,0,12.57-10.03,20.82-25.13,20.82s-25.89-8.38-25.89-20.56Z"/></svg>';

  // webapp/js/app.js
  var STORAGE_KEY = "casper-creative-profile-quiz:v1";
  var MIN_YEAR = 1930;
  var MAX_YEAR = (/* @__PURE__ */ new Date()).getFullYear() - 5;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var NICKNAME_RE = /^[A-Za-z][A-Za-z .'-]{0,39}$/;
  var app = document.getElementById("app");
  var state = {
    lang: DEFAULT_LANG,
    screen: "intro",
    person: null,
    attempt: null
  };
  var view = { errors: {}, form: {}, google: null, manualOpen: false, messageKey: "" };
  function load() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (saved) state = { ...state, ...saved };
    } catch {
    }
    loadResultFromLink();
    if (state.attempt && isComplete(state.attempt)) state.screen = "result";
    else state.screen = "intro";
  }
  function resultLink() {
    const digits = questions.map((q) => (state.attempt.answers[q.id] ?? 0) + 3).join("");
    return `${location.origin}${location.pathname}?r=${digits}&l=${state.lang}`;
  }
  function syncAddressBar() {
    const wanted = state.screen === "result" && isInAppBrowser() ? resultLink() : location.origin + location.pathname;
    if (location.href !== wanted) history.replaceState(null, "", wanted);
  }
  function loadResultFromLink() {
    const params = new URLSearchParams(location.search);
    const digits = params.get("r");
    if (!digits) return;
    history.replaceState(null, "", location.pathname);
    if (!/^[0-6]{15}$/.test(digits)) return;
    state.attempt = {
      responseId: `link-${newId()}`,
      answers: Object.fromEntries(questions.map((q, i) => [q.id, digits[i] === "3" ? null : Number(digits[i]) - 3])),
      index: questions.length - 1,
      questionStartedAt: null,
      timedOut: [],
      resultSent: true
      // already saved from the browser where the quiz was taken
    };
    if (params.get("l") === "en" || params.get("l") === "th") state.lang = params.get("l");
    persist();
  }
  function persist() {
    try {
      const { lang, person, attempt } = state;
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ lang, person, attempt }));
    } catch {
    }
  }
  function t(key, vars = {}) {
    let text = ui[key][state.lang];
    for (const [k, v] of Object.entries(vars)) text = text.replace(`{${k}}`, v);
    return text;
  }
  function tl(key, vars) {
    return t(key, vars).replace(/\n/g, "<br>");
  }
  function esc(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  }
  function isComplete(attempt) {
    return questions.every((q) => q.id in attempt.answers);
  }
  function newId() {
    return crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  function go(screen) {
    state.screen = screen;
    view = { errors: {}, form: view.form, google: view.google, manualOpen: false, messageKey: "" };
    persist();
    render();
    window.scrollTo(0, 0);
  }
  function currentGoogleToken() {
    const google = state.person?.google;
    return google && google.expiresAt > Date.now() + 6e4 ? google.token : void 0;
  }
  function registrationPayload(attempt) {
    const p = state.person;
    return {
      responseId: attempt.responseId,
      name: p.name,
      email: p.email,
      yearOfBirth: p.yearOfBirth,
      consent: p.consent,
      marketingOptIn: p.marketingOptIn,
      lang: state.lang,
      idToken: attempt.idToken
    };
  }
  function startAttempt() {
    state.attempt = {
      responseId: newId(),
      answers: {},
      index: 0,
      questionStartedAt: null,
      timedOut: [],
      resultSent: false,
      idToken: currentGoogleToken()
    };
    saveRegistration(registrationPayload(state.attempt));
  }
  function validate(form) {
    const errors = {};
    if (!NICKNAME_RE.test(form.name)) errors.name = t("errName");
    if (!EMAIL_RE.test(form.email)) errors.email = t("errEmail");
    const year = Number(form.yearOfBirth);
    if (!Number.isInteger(year) || year < MIN_YEAR || year > MAX_YEAR) {
      errors.yearOfBirth = t("errYob");
    }
    if (!form.consent) errors.consent = t("errConsent");
    return errors;
  }
  function onRegister(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    if (data.get("company")) return;
    const google = view.google;
    const form = {
      name: String(data.get("name") || "").trim(),
      email: google ? google.email : String(data.get("email") || "").trim().toLowerCase(),
      yearOfBirth: String(data.get("yearOfBirth") || "").trim(),
      consent: data.get("consent") === "on",
      marketingOptIn: data.get("marketingOptIn") === "on"
    };
    view.form = form;
    view.errors = validate(form);
    if (Object.keys(view.errors).length) return render();
    state.person = { ...form, yearOfBirth: Number(form.yearOfBirth), google };
    startAttempt();
    go("quiz");
  }
  function onGoogleCredential(credential) {
    try {
      const google = readCredential(credential);
      view.google = google;
      view.form = { ...view.form, email: google.email };
      view.errors = {};
      view.messageKey = "";
    } catch (err) {
      console.error(err);
      view.messageKey = "errGoogle";
    }
    render();
  }
  function onGoogleOther() {
    view.google = null;
    view.manualOpen = true;
    view.form = { ...view.form, email: "" };
    render();
  }
  function onManualForm() {
    view.manualOpen = true;
    render();
    app.querySelector("#f-name")?.focus();
  }
  function onStart() {
    if (state.person && state.attempt && !isComplete(state.attempt)) {
      const attempt = state.attempt;
      const next = questions.findIndex((q) => !(q.id in attempt.answers));
      if (next !== attempt.index) {
        attempt.index = next;
        attempt.questionStartedAt = null;
      }
      return go("quiz");
    }
    go("howto");
  }
  function onHowtoStart() {
    if (!state.person) return go("register");
    startAttempt();
    go("quiz");
  }
  function onNotYou() {
    state.person = null;
    state.attempt = null;
    view.form = {};
    view.google = null;
    go("register");
  }
  var ADVANCE_DELAY_MS = 450;
  var SKIP_NOTICE_MS = 1200;
  var QUESTION_TIME_MS = 6e4;
  var WARNING_MS = 1e4;
  var advancing = false;
  var ticker = null;
  var skippedNotice = false;
  function onAnswer(value, { timedOut = false } = {}) {
    if (advancing) return;
    const attempt = state.attempt;
    const question = questions[attempt.index];
    attempt.answers[question.id] = timedOut ? null : value;
    if (timedOut) attempt.timedOut = [...attempt.timedOut || [], question.id];
    persist();
    advancing = true;
    skippedNotice = timedOut;
    render();
    setTimeout(() => {
      advancing = false;
      skippedNotice = false;
      if (attempt.index < questions.length - 1) {
        attempt.index += 1;
        attempt.questionStartedAt = null;
        persist();
        render();
        app.querySelector("h2")?.focus();
        return;
      }
      sendResult();
      go("result");
    }, timedOut ? SKIP_NOTICE_MS : ADVANCE_DELAY_MS);
  }
  function tick() {
    const attempt = state.attempt;
    if (state.screen !== "quiz" || !attempt || advancing) return;
    if (!attempt.questionStartedAt) {
      attempt.questionStartedAt = Date.now();
      persist();
    }
    const left = Math.max(0, attempt.questionStartedAt + QUESTION_TIME_MS - Date.now());
    paintTimer(left);
    if (left === 0) onAnswer(null, { timedOut: true });
  }
  function timeLeft() {
    const started = state.attempt?.questionStartedAt;
    return started ? Math.max(0, started + QUESTION_TIME_MS - Date.now()) : QUESTION_TIME_MS;
  }
  function clock(ms) {
    const s = Math.ceil(ms / 1e3);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  }
  function paintTimer(left) {
    const timer = app.querySelector("[data-timer]");
    if (!timer) return;
    timer.querySelector(".timer-num").textContent = clock(left);
    timer.querySelector(".timer-fill").style.width = `${left / QUESTION_TIME_MS * 100}%`;
    timer.classList.toggle("warning", left <= WARNING_MS);
  }
  function syncTimer() {
    if (state.screen === "quiz") {
      if (!ticker) ticker = setInterval(tick, 200);
      paintTimer(timeLeft());
      tick();
    } else if (ticker) {
      clearInterval(ticker);
      ticker = null;
    }
  }
  function sendResult() {
    const attempt = state.attempt;
    if (attempt.resultSent || !state.person) return;
    const result = calculateQuizResult(attempt.answers, questions);
    saveResult(registrationPayload(attempt), state.lang, attempt.answers, attempt.timedOut || [], result);
    attempt.resultSent = true;
    persist();
  }
  function onRetake() {
    state.attempt = null;
    go("intro");
  }
  function currentResult() {
    const result = calculateQuizResult(state.attempt.answers, questions);
    return { result, profile: profiles[result.profile] };
  }
  function imageKey(kind) {
    return `${state.attempt.responseId}:${state.lang}:${kind}`;
  }
  function imageFilename(kind) {
    return `casper-creative-profile-${currentResult().result.profile}-${kind}.png`;
  }
  function buildStoryNode() {
    const { result, profile } = currentResult();
    const L = state.lang;
    const node = document.createElement("div");
    node.className = "story";
    node.lang = L;
    node.innerHTML = `
    <div class="card">
      <div class="story-logo">${LOGO_SVG}</div>
      <div class="story-main">
        ${resultTop(result, profile)}
        ${spectraBoxes(result)}
        <h3 class="section-title">${t("strengths")}</h3>
        <p class="dotted">${dotted(profile.strengths[L])}</p>
        <h3 class="section-title">${t("thrive")}</h3>
        <p class="dotted">${dotted(profile.thrive[L])}</p>
      </div>
      <p class="story-footer"><strong>Casper Schools</strong> \xB7 Creative Profile Quiz</p>
    </div>`;
    return node;
  }
  function prepareImages() {
    setTimeout(() => {
      if (state.screen !== "result") return;
      renderImage(imageKey("story"), buildStoryNode).catch((err) => console.warn("Image preparation failed", err));
    }, 300);
  }
  function overlayText() {
    return { hint: t("saveHint"), download: t("saveImage"), close: t("close") };
  }
  async function onShare() {
    if (isInAppBrowser()) {
      return showOpenInBrowser(resultLink(), {
        title: t("openTitle"),
        bodyIOS: t("openBodyIOS"),
        bodyAndroid: t("openBodyAndroid"),
        openInChrome: t("openInChrome"),
        copyLink: t("copyLink"),
        copied: t("copied"),
        saveInstead: t("saveInstead"),
        close: t("close")
      }, onSaveInstead);
    }
    let blob;
    try {
      blob = await renderImage(imageKey("story"), buildStoryNode);
    } catch (err) {
      console.error(err);
      return alert(t("imageFailed"));
    }
    const filename = imageFilename("story");
    const outcome = await shareImage(blob, filename);
    if (outcome === "unsupported") showSaveOverlay(blob, filename, overlayText());
  }
  async function onDownload() {
    try {
      const blob = await renderImage(imageKey("story"), buildStoryNode);
      downloadImage(blob, imageFilename("story"));
    } catch (err) {
      console.error(err);
      alert(t("imageFailed"));
    }
  }
  async function onSaveInstead() {
    try {
      const blob = await renderImage(imageKey("story"), buildStoryNode);
      showSaveOverlay(blob, imageFilename("story"), overlayText());
    } catch (err) {
      console.error(err);
      alert(t("imageFailed"));
    }
  }
  function onLang(lang) {
    state.lang = lang;
    if (Object.keys(view.errors).length) view.errors = validate(view.form);
    persist();
    render();
  }
  function header() {
    const btn = (lang, label) => `<button type="button" class="lang-btn" data-lang="${lang}" aria-pressed="${state.lang === lang}">${label}</button>`;
    return `
    <header class="topbar">
      ${LOGO_SVG}
      <div class="lang" role="group" aria-label="Language">${btn("th", "TH")}${btn("en", "EN")}</div>
    </header>`;
  }
  function introView() {
    const p = state.person;
    const inProgress = p && state.attempt && !isComplete(state.attempt);
    return `
    <section class="screen intro">
      <img class="intro-art" src="${IMAGES.group}" alt="" width="1100" height="795" decoding="async" onerror="this.remove()">
      <div class="intro-text">
        <h1 class="intro-title"><span>Creative Profile</span> <mark>Quiz</mark></h1>
        <p class="opening-question">${tl("openingQuestion")}</p>
        <hr class="intro-rule">
        <p class="opening-statement">${t("openingStatement")}</p>
        <p class="opening-description">${tl("openingDescription")}</p>
      </div>
      <div class="intro-actions">
        <button type="button" class="btn primary" data-action="start">${inProgress ? t("continueQuiz") : t("beginButton")}</button>
        ${p ? `<button type="button" class="btn link" data-action="not-you">${esc(t("newPerson", { name: p.name }))}</button>` : ""}
        <div class="stats" data-stats hidden></div>
      </div>
    </section>`;
  }
  function howtoView() {
    const strengths = ["strengthHigh", "strengthMedium", "strengthLow", "strengthLow", "strengthMedium", "strengthHigh"];
    return `
    <section class="screen howto">
      <div class="howto-intro">
        <h1 class="howto-title">${t("howtoTitle")}</h1>
        <p class="howto-details">${t("howtoDetails")}</p>
        <p class="howto-perspectives">${tl("howtoPerspectives")}</p>
        <p class="howto-steps">&rarr; ${t("howtoStep1")}<br>&rarr; ${t("howtoStep2")}</p>
      </div>
      <div class="howto-scale" aria-hidden="true">
        <div class="hs-head left">${t("leftLabel")}</div>
        <div class="hs-head right">${t("rightLabel")}</div>
        ${strengths.map((k, i) => `<div class="hs-block c${i + 1}"></div>`).join("")}
        ${strengths.map((k, i) => `<div class="hs-label ${i < 3 ? "left" : "right"}">${t(k)}</div>`).join("")}
      </div>
      <div class="howto-notes">
        <p>${tl("answerGuidance")}</p>
        <p>${tl("timeoutGuidance")}</p>
        <p>${tl("notFixedGuidance")}</p>
      </div>
      <button type="button" class="btn primary" data-action="howto-start">${t("startButton")}</button>
    </section>`;
  }
  var stats = null;
  async function refreshStats() {
    const fresh = await loadStats();
    if (fresh) {
      stats = fresh;
      paintStats();
    }
  }
  function percentages(counts, total) {
    const exact = counts.map((c) => c / total * 100);
    const result = exact.map(Math.floor);
    let left = 100 - result.reduce((a, b) => a + b, 0);
    exact.map((v, i) => [v - Math.floor(v), i]).sort((a, b) => b[0] - a[0]).forEach(([, i]) => {
      if (left > 0) {
        result[i] += 1;
        left -= 1;
      }
    });
    return result;
  }
  function paintStats() {
    const el = app.querySelector("[data-stats]");
    if (!el) return;
    if (!stats || stats.total < STATS_MIN_PEOPLE) {
      el.hidden = true;
      return;
    }
    const L = state.lang;
    const ids = Object.keys(profiles);
    const pcts = percentages(ids.map((id) => stats.profiles[id] || 0), stats.total);
    const rows = ids.map((id, i) => ({ id, pct: pcts[i] })).sort((a, b) => b.pct - a.pct);
    el.hidden = false;
    el.innerHTML = `
    <p class="stats-title">${t("statsTitle")}</p>
    ${stats.total >= SHOW_PEOPLE_COUNT_FROM ? `<p class="stats-count">${t("statsCount", { n: stats.total.toLocaleString("en-US") })}</p>` : ""}
    <ul class="stats-list">
      ${rows.map(({ id, pct }) => `
        <li>
          <div class="stats-row"><span>${profiles[id].name[L]}</span><span class="stats-pct">${pct}%</span></div>
          <div class="stats-bar" aria-hidden="true"><span style="width:${pct}%"></span></div>
        </li>`).join("")}
    </ul>`;
  }
  function field(name, label, input) {
    const error = view.errors[name];
    return `
    <div class="field ${error ? "has-error" : ""}">
      <label for="f-${name}">${label}</label>
      ${input}
      ${error ? `<p class="error" id="e-${name}">${error}</p>` : ""}
    </div>`;
  }
  function yearPicker(value, ariaAttrs) {
    const options = [];
    for (let y = MAX_YEAR; y >= MIN_YEAR; y--) {
      const label = state.lang === "th" ? `${y} (\u0E1E.\u0E28. ${y + 543})` : `${y}`;
      options.push(`<option value="${y}" ${String(value) === String(y) ? "selected" : ""}>${label}</option>`);
    }
    return `
    <div class="select-wrap">
      <select id="f-yearOfBirth" name="yearOfBirth" ${ariaAttrs}>
        <option value="" disabled ${value ? "" : "selected"}>${t("yobPlaceholder")}</option>
        ${options.join("")}
      </select>
    </div>`;
  }
  function registerView() {
    const f = view.form;
    const aria = (name) => view.errors[name] ? `aria-invalid="true" aria-describedby="e-${name}"` : "";
    const withGoogle = googleAvailable();
    const google = view.google;
    const showForm = !withGoogle || google || view.manualOpen;
    const emailField = google ? `<div class="field">
        <span class="field-label">${t("emailLabel")}</span>
        <div class="verified-email">
          <span>${esc(google.email)}</span>
          <span class="verified-badge">&#10003; Google</span>
        </div>
        <button type="button" class="btn link google-other" data-action="google-other">${t("googleUseOther")}</button>
      </div>` : field(
      "email",
      t("emailLabel"),
      `<input id="f-email" name="email" type="email" autocomplete="email" inputmode="email" maxlength="254" value="${esc(f.email || "")}" ${aria("email")}>`
    );
    return `
    <section class="screen register">
      <div class="register-intro">
        <h1>${t("registerTitle")}</h1>
        <p class="lead">${!withGoogle ? t("registerBody") : showForm ? t("registerBodyGoogle") : t("registerBodyGoogleFirst")}</p>
      </div>
      <div class="register-body">
      ${view.messageKey ? `<p class="form-error google-error" role="alert">${t(view.messageKey)}</p>` : ""}
      ${withGoogle && !google ? `
        <div class="google-block" data-google>
          <div class="google-button" data-google-button></div>
          ${showForm ? `<p class="or"><span>${t("orFillIn")}</span></p>` : `<button type="button" class="btn link manual-toggle" data-action="manual-form">${t("manualToggle")}</button>`}
        </div>` : ""}
      ${showForm ? `
      <form novalidate data-form="register">
        ${field(
      "name",
      t("nameLabel"),
      `<input id="f-name" name="name" type="text" autocomplete="nickname" autocapitalize="words" lang="en" maxlength="40" value="${esc(f.name || "")}" ${aria("name")}>`
    )}
        ${emailField}
        ${field("yearOfBirth", t("yobLabel"), yearPicker(f.yearOfBirth, aria("yearOfBirth")))}

        <div class="hp" aria-hidden="true">
          <label>Company <input name="company" tabindex="-1" autocomplete="off"></label>
        </div>

        <div class="checks">
        <div class="check ${view.errors.consent ? "has-error" : ""}">
          <label>
            <input type="checkbox" name="consent" ${f.consent ? "checked" : ""} ${aria("consent")}>
            <span>${t("consentLabel")} <a href="${PRIVACY_POLICY_URL}" target="_blank" rel="noopener">${t("privacyPolicy")}</a></span>
          </label>
          ${view.errors.consent ? `<p class="error" id="e-consent">${view.errors.consent}</p>` : ""}
        </div>
        <div class="check">
          <label>
            <input type="checkbox" name="marketingOptIn" ${f.marketingOptIn ? "checked" : ""}>
            <span>${t("marketingLabel")}</span>
          </label>
        </div>
        </div>

        <button type="submit" class="btn primary">${t("submit")}</button>
      </form>` : ""}
      </div>
    </section>`;
  }
  function choiceLabel(value) {
    return answerOptions.find((o) => o.value === value)?.[state.lang] ?? "";
  }
  function quizView() {
    const { index, answers } = state.attempt;
    const q = questions[index];
    const L = state.lang;
    const selected = answers[q.id];
    const label = skippedNotice ? t("timeUpSkipped") : typeof selected === "number" ? choiceLabel(selected) : t("whichSide");
    return `
    <section class="screen quiz">
      <p class="q-count">${t("questionOf", { n: index + 1, total: questions.length })}</p>
      <div class="q-box" data-fit="18"><h2 class="question" tabindex="-1">${q.prompt[L]}</h2></div>
      <p class="choice-hint ${skippedNotice ? "skipped" : typeof selected === "number" ? "chosen" : ""}" data-choice-label aria-live="polite">${label}</p>
      <div class="choice" role="radiogroup" aria-label="${esc(q.prompt[L])}">
        <div class="choice-side left"><div class="side-box" data-fit="12"><p>${q.left[L]}</p></div></div>
        <div class="choice-side right"><div class="side-box" data-fit="12"><p>${q.right[L]}</p></div></div>
        ${answerOptions.map((o, i) => `
          <button type="button" class="block c${i + 1}" role="radio" aria-checked="${selected === o.value}"
            aria-label="${esc(o[L])}" data-answer="${o.value}"></button>`).join("")}
      </div>
      <div class="timer" data-timer role="timer" aria-label="${t("timeLeft")}">
        <span class="timer-num" aria-hidden="true">${clock(timeLeft())}</span>
        <div class="timer-track"><div class="timer-fill"></div></div>
        <p class="timer-note">${t("timeoutNote")}</p>
      </div>
      <footer class="quiz-footer">
        <strong>Creative Profile Quiz by Casper Schools</strong>
        <span>&copy; All Rights Reserved</span>
      </footer>
    </section>`;
  }
  function fitTexts() {
    app.querySelectorAll("[data-fit]").forEach((box) => {
      const text = box.firstElementChild;
      if (!text) return;
      text.style.fontSize = "";
      const style = getComputedStyle(box);
      const room = box.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      let size = parseFloat(getComputedStyle(text).fontSize);
      const min = Number(box.dataset.fit) || 12;
      while (text.offsetHeight > room && size > min) {
        size -= 1;
        text.style.fontSize = `${size}px`;
      }
    });
  }
  var fitTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitTexts, 100);
  });
  document.fonts?.ready.then(fitTexts);
  function spectrum(title, leftPole, leftPct, rightPole, rightPct) {
    const L = "en";
    return `
    <div class="spectrum">
      <h3 class="spectrum-title">${title}</h3>
      <div class="spectrum-line" role="img"
        aria-label="${esc(`${poles[leftPole][L]} ${leftPct}%, ${poles[rightPole][L]} ${rightPct}%`)}">
        <span class="marker" style="--pos:${rightPct}%"></span>
      </div>
      <div class="spectrum-poles" aria-hidden="true">
        <span><b>${leftPct}%</b>${poles[leftPole][L]}</span>
        <span><b>${rightPct}%</b>${poles[rightPole][L]}</span>
      </div>
    </div>`;
  }
  function ghostImage(profileId) {
    return `<img class="ghost" src="${IMAGES[profileId]}" alt="" decoding="async" onerror="this.remove()">`;
  }
  function resultTop(result, profile) {
    return `
    <p class="eyebrow">${t("yourProfile")}</p>
    <h1 class="profile-name">${profile.name[state.lang]}</h1>
    <div class="hero">${ghostImage(result.profile)}</div>`;
  }
  function spectraBoxes(result) {
    const { responsive, expressive } = result.spectrum.creativeOrientation;
    const { structured, exploratory } = result.spectrum.creativeProcess;
    return `
    <div class="spectra">
      ${spectrum(t("creativeOrientation"), "responsive", responsive, "expressive", expressive)}
      ${spectrum(t("creativeProcess"), "structured", structured, "exploratory", exploratory)}
    </div>`;
  }
  function dotted(list) {
    return list.map((item, i) => `<span>${item}${i < list.length - 1 ? '<i aria-hidden="true">&bull;</i>' : ""}</span>`).join(" ");
  }
  function resultView() {
    const result = calculateQuizResult(state.attempt.answers, questions);
    const profile = profiles[result.profile];
    const L = state.lang;
    return `
    <section class="screen result">
      <article class="card" id="result-card">
        <div class="result-side">${resultTop(result, profile)}</div>
        <div class="result-main">
        <p class="description">${profile.description[L].join(" ")}</p>
        ${spectraBoxes(result)}
        <h3 class="section-title">${t("strengths")}</h3>
        <p class="dotted">${dotted(profile.strengths[L])}</p>
        <h3 class="section-title">${t("thrive")}</h3>
        <p class="dotted">${dotted(profile.thrive[L])}</p>
        <p class="disclaimer">${disclaimer[L]}</p>
        </div>
      </article>

      ${state.person && state.attempt.resultSent ? `<p class="save-status" data-save-status role="status" aria-live="polite"></p>` : ""}
      <div class="actions">
        <div class="action-buttons">
          <button type="button" class="btn primary" data-action="share">${t("share")}</button>
          ${isDesktop() ? `<button type="button" class="btn outline" data-action="download">${t("saveImage")}</button>` : ""}
        </div>
        <button type="button" class="btn link" data-action="retake">${t("retake")}</button>
      </div>
    </section>`;
  }
  function paintSaveStatus(pending) {
    const el = app.querySelector("[data-save-status]");
    if (!el) return;
    el.textContent = pending ? t("resultSaving") : t("resultSaved");
    el.classList.toggle("done", !pending);
  }
  onSaveStatusChange(paintSaveStatus);
  var views = { intro: introView, howto: howtoView, register: registerView, quiz: quizView, result: resultView };
  function render() {
    document.documentElement.lang = state.lang;
    app.innerHTML = header() + `<main class="main-${state.screen}">${views[state.screen]()}</main>`;
    syncTimer();
    if (state.screen === "quiz") fitTexts();
    if (state.screen === "intro") paintStats();
    if (state.screen === "result") {
      prepareImages();
      paintSaveStatus(pendingSaves());
    }
    const googleSlot = app.querySelector("[data-google-button]");
    if (googleSlot) mountGoogleButton(googleSlot, state.lang, onGoogleCredential);
    syncAddressBar();
  }
  app.addEventListener("click", (event) => {
    const el = event.target.closest("[data-lang], [data-action], [data-answer]");
    if (!el) return;
    if (el.dataset.lang) return onLang(el.dataset.lang);
    if (el.dataset.answer !== void 0) return onAnswer(Number(el.dataset.answer));
    const actions = {
      start: onStart,
      "howto-start": onHowtoStart,
      "not-you": onNotYou,
      retake: onRetake,
      share: onShare,
      download: onDownload,
      "google-other": onGoogleOther,
      "manual-form": onManualForm
    };
    actions[el.dataset.action]?.();
  });
  function previewChoice(event) {
    if (state.screen !== "quiz" || advancing) return;
    const labelEl = app.querySelector("[data-choice-label]");
    const dot = event.target.closest?.("[data-answer]");
    if (!labelEl) return;
    labelEl.textContent = dot && event.type !== "pointerout" && event.type !== "focusout" ? choiceLabel(Number(dot.dataset.answer)) : t("whichSide");
  }
  ["pointerover", "pointerout", "focusin", "focusout"].forEach((type) => app.addEventListener(type, previewChoice));
  app.addEventListener("input", (event) => {
    const { name, type, checked, value } = event.target;
    if (!name || state.screen !== "register") return;
    view.form = { ...view.form, [name]: type === "checkbox" ? checked : value };
  });
  app.addEventListener("submit", (event) => {
    if (event.target.dataset.form === "register") onRegister(event);
  });
  load();
  if (state.screen === "result") sendResult();
  render();
  flush();
  refreshStats();
})();
